import { render, staticRenderFns } from "./childrenorder.vue?vue&type=template&id=7ada690e&scoped=true&"
import script from "./childrenorder.vue?vue&type=script&lang=js&"
export * from "./childrenorder.vue?vue&type=script&lang=js&"
import style0 from "./childrenorder.vue?vue&type=style&index=0&id=7ada690e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ada690e",
  null
  
)

export default component.exports